import React, { useRef, useEffect, useCallback } from 'react';
import { gsap } from '../../../../gsap';
import CopyWithBar from '../../../Common/CopyBlocks/CopyWithBar';
import './Torso.scss';

function ArtemisTorso({ screenWidth }) {
  const artemisTorsoSection = useRef();
  const artemisTorsoCanvas = useRef();
  const artemisTorsoLower = useRef();
  const artemisTorsoAnimation = useRef();
  const images = useRef([]);
  const ratio = useRef();
  const bar = useRef();
  const copyData =
    'The xEMU design allows wearers to climb into the suit through a “rear-entry” hatch in the back, which also improves fit in tricky areas like the shoulders. The eventual suit design may have both waist entry and rear-entry versions, to better adapt to the needs of different wearers.';

  const playOnScroll = useCallback(() => {
    ratio.current = 1.77;
    images.current = [];
    // set canvas properties
    const canvas = artemisTorsoCanvas.current.getContext('2d');
    // Set the size of the canvas
    artemisTorsoCanvas.current.width =
      screenWidth > 480 ? Math.min(window.innerWidth * 0.3, 486) : window.innerWidth;
    artemisTorsoCanvas.current.height = artemisTorsoCanvas.current.width * ratio.current;

    // Count the frames and set the path to the images
    const frameCount = 30;
    const currentFrame = (index) =>
      `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/artemis/torso/XEMU_TORSO${(
        index + 1
      )
        .toString()
        .padStart(2, '0')}.png`;
    // Set start frame

    const torso = {
      frame: 0
    };

    // Go through frames from start to finish
    const torsoAnim = gsap.timeline({
      scrollTrigger: {
        trigger: artemisTorsoSection.current,
        start: 'top top',
        endTrigger: artemisTorsoSection.current,
        end: 'bottom bottom',
        scrub: 1
      }
    });

    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.current.push(img);
    }

    torsoAnim.add('start').to(
      torso,
      {
        frame: frameCount - 1,
        snap: 'frame',
        duration: 5,
        ease: 'linear',
        onUpdate: render
      },
      'start'
    );

    images.current[0].onload = render;

    function render() {
      canvas.clearRect(0, 0, artemisTorsoCanvas.current.width, artemisTorsoCanvas.current.height);
      canvas.drawImage(
        images.current[torso.frame],
        0,
        0,
        artemisTorsoCanvas.current.width,
        artemisTorsoCanvas.current.height
      );
    }
  }, [screenWidth, images]);

  useEffect(() => {
    playOnScroll();
  }, [screenWidth, playOnScroll]);

  return (
    <section className="torso torso-artemis" ref={artemisTorsoSection}>
      <div className="torso__upper torso__upper-artemis">
        <h3 className="torso__upper__title">
          For the xEMU prototype, fit is achieved through biometric scans and 3D modeling, allowing
          each person to choose the right combination of modular components.
        </h3>
      </div>
      <div className="torso__lower-artemis">
        <div className="torso__animation torso__animation-artemis" ref={artemisTorsoAnimation}>
          <canvas className="torso__animation__canvas" ref={artemisTorsoCanvas} />
        </div>

        <div className="torso__textWBar torso__textWBar-artemis" ref={artemisTorsoLower}>
          <CopyWithBar copyData={copyData} />
        </div>
      </div>
    </section>
  );
}

export default ArtemisTorso;
